module.exports = __webpack_public_path__ + "images/icon-top-sac---d21b29ab2d14ba50fd440c30c4e447d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app/images/icon-top-sac.png
// module id = 388
// module chunks = 0